import styles from './TestimonialWithImages.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import { TestimonialAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import { TextSection } from 'components/Testimonial/Text/TextSection';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';
import { FlatEntry } from 'services/cms/flattenContentful';
import { AppType, toSysId } from 'services/cms/typesUtil';
import { FadeToastUp } from 'components/Animation/FadeToastUp/FadeToastUp';

type TestimonialWithImagesProps = AppType.Component<FlatEntry<TestimonialAssembly>>;

export const TestimonialWithImages: FC<TestimonialWithImagesProps> = ({
  testimony,
  items,
  merchant,
  ...props
}) => {
  if (!testimony || !merchant || !items) return null;

  const firstThreeImages = items.filter(i => i.image?.file?.url).slice(0, 3);

  return (
    <FadeToastUp>
      <div className={styles.testimonialModule} {...props}>
        <div
          className={cx(
            styles.imageWrapper,
            firstThreeImages.length == 2 && styles.imageWrapperDouble,
            firstThreeImages.length == 3 && styles.imageWrapperTriple,
          )}
        >
          {firstThreeImages.map(image => (
            <SubjectImage key={toSysId(image)} entry={image} className={styles.image} />
          ))}
        </div>
        <TextSection testimony={testimony} merchant={merchant} />
      </div>
    </FadeToastUp>
  );
};
